import { ObservableArray, View } from "binder"
import { PreOrderListViewModel, item } from "./preOrderList-viewModel"

export class PreOrderListView extends View<PreOrderListViewModel>{
    GetViewUniqueId(): string {
        return "V-6A7D4B0D-72BC-4269-BF87-C1307128AD6D"
    }
    loadHtml(): string {
        let element = require('./preOrderList.html').default;
        let style = require('./preOrderList.less');
        return element;
    }
    constructor() {
       super();
    }

    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<item>) { this._items = v; } public get items(): ObservableArray<item> { return this._items;} private _items: ObservableArray<item>;

}
